<template>
  <div class="camsContainer">
    <div class="nonGraphContainer">
      <div class="pageHeader">
        <ContentHeader :name=this.headerName :subHeader="subHeader" :route="subPage" />
        <div>
          <button class="createButton" @click="(event) => handleButtonPress(event)">Add Vendor</button>
          <button @click="(event) => handleButtonPress(event)">Pay a Vendor</button>
        </div>
      </div>
      <!-- <Insights :cardInfo="cardInfo" :callback="updateFiltersForSearchBasedOnCard" /> -->
    </div>


    <div class="currentView">
      <div>
        <div class="dataTableSelectorGroup">
          <div class="dataTableSelector">
            <SearchBar class="gate-search" v-bind:search="search" :searchIcon="true"
              v-bind:searchCallback="(data) => { this.performSearch(data) }" placeholder="Enter Search" />
            
          </div>
        </div>
        <DataTable v-bind:tableData="tableData" v-bind:configuration="selectedItem" v-bind:openModalCallback="(data) => {
          handleModal(selectedItem, data); 
        }
          " :search=search :processInputData="this.processInputData" :headers="headers" />
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from "../../ContentHeader";
import * as Constants from "../../../js/constants";
import EventBus from "../../../eventBus";
import DataTable from "../pageComps/DataTable.vue";
import SearchBar from "../pageComps/Search.vue";
import CTSRepository from "../../../js/CTSRepository";
// import Insights from "../../layout/Insights.vue";

export default {
  name: "FrequentVisitors",
  props: ["subPage", "organizationData"],
  components: {
    ContentHeader,
    DataTable,
    SearchBar,
    // Insights
  },
  data() {
    return {
      selectedItem: Constants.FREQUENT_VISITORS,
      filterStartDate: null,
      filterEndDate: null,
      defaultStartDate: null,
      defaultEndDate: null,
      headerName: Constants.USERS,
      subHeader: "Here's a log of all keys sent for your Community.",
      page: this.subPage ? this.subPage : "",
      headers: [
        { text: "Company Name", value: "company_name", align: "start", sortable: true, width: 300 },
        { text: "Primary Contact", value: "primary_contact_name", filterable: true, width: 175 },
        { text: "Authorized Personnel", value: "authorized_personnel_name", width: 175 },
        { text: "Service Type", value: "service_type", filterable: false, width: 180 },
        { text: "Schedule", value: "schedule", filterable: false, width: 180 },
        { text: "Times Visited", value: "times_visited", filterable: false, width: 175 },
        { text: "Expiration Date", value: "expiration", filterable: false, width: 180 },
        { text: "Vendor Status", value: "status", filterable: false, width: 180 },
        { text: "Authorization Date", value: "time_created", filterable: false, width: 180 },
        { text: "Phone Number", value: "visitor_phone_number", filterable: false, width: 180 },
        { text: "Vendor ID", value: "vendor_uid", filterable: false, width: 180 },
      ],
      defaultFilters: {
        residentName: null,
        visitorName: null,
        subdivision: null,
        status: null,
        startTime: null,
        endTime: null
      },
      filters: {},
      tableData: [],
      search: "",
      cardInfo: [
        {
          title: "Total Keys Sent",
          value: "70",
          filters: {

          }
        },
        {
          title: "Total Keys Validated",
          value: "30",
          filters: {
            residentName: "",
            visitorName: "",
            subdivision: "",
            status: "VALIDATED",
            startTime: null,
            endTime: null
          }
        },
        {
          title: "Total Keys Pending",
          value: "3",
        },
        {
          title: "Total Keys Denied",
          value: "1",
        },
        {
          title: "Party Keys Created",
          value: "30",
          filters: {
            residentName: "",
            visitorName: "",
            subdivision: "",
            status: "CREATED",
            startTime: null,
            endTime: null
          }
        }
      ],
    };
  },
  created() {
    console.log("Gate", this)
    this.changeView(this.selectedItem);
    EventBus.$on("keys", this.changeView);
    EventBus.$on("incidents", this.changeView);

    var date = new Date();
    this.defaultEndDate = date.toISOString().split("T")[0];
    var startDate = new Date(date);
    startDate.setDate(date.getDate() - 7);
    //this.defaultStartDate = startDate.toISOString().split('T')[0]
    this.defaultStartDate = "2019-06-06";
    this.filters = this.defaultFilters

  },
  watch: {
    search(newVal) {
      this.filters = this.defaultFilters
      if (newVal == "") {
        this.performSearch()
      }
    },
    organizationData(newVal) {
      if(newVal != null) {
        this.performSearch()
      }
    }
  },
  methods: {
    openGateFiletersModal() {
      console.log("Opening Gate Filters Modal");
    },
    homeChangeText() {
      console.log("Home knows the button was clicked");
    },
    changeView(name) {
      console.log("Changing View fro ", this.selectedItem, " to ", name);
    },
    // TODO: Ensure the organizationData is available AND fix query
    performSearch(data) {
      this.search = data
      if(this.$props.organizationData == null || this.$props.organizationData == undefined) return
      new CTSRepository(this.$props.organizationData).fetchVendors()
          .then((data) => {
            console.log("Search Data", data);
            this.tableData = data.data
          })
          .catch((err) => {
            console.log("Error fetching Vendors", err)
          });
    },
    processInputData(inputData) {
      return inputData.map(item => {
        console.log("Mapping over item", item)
        return {
          ...item,
          primary_contact_name: `${item.primary_contact_first_name} ${item.primary_contact_last_name}`,
          authorized_personnel_name: `${item.authorized_personnel_first_name} ${item.authorized_personnel_last_name}`,
        }
      })
    },
    updateFiltersForSearchBasedOnCard(card) {
      this.filters = card.filters ?? this.defaultFilters
      this.performSearch(this.search).then(() => {
      })
    },
    openGateModal() {
      this.$modal.show(Constants.GATE_MODAL);
    },
    openUsersModal() {
      this.$modal.show("users-modal");
    },
    handleModal(configuration, data) {
      EventBus.$emit(Constants.UPDATE_KEY_MODAL_DATA, data)
      switch (configuration) {
        case Constants.GATE: {
          console.log("Opening Gate Modal")
          this.openGateModal();
          break;
        }
      }
    },
    handleButtonPress() {
      this.$modal.show(Constants.CREATE_VENDOR_MODAL)
    }
  },
};
</script>

<style scoped>
.pageHeader div button {
    background-color: #87bab7;
    color: white;
}

.createButton {
  background-color: #1890FFCC !important;
  margin-right: 24px;
}

.dataTableSelectorGroup {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 16px;
}

.dataTableSelector:nth-child(3n) {
  margin-right: 0px;
}

.selectorContent {
  width: 100%;
  color: white;
  font-size: 28px;
}

.selectorContent::placeholder {
  width: 100%;
  color: white;
  font-size: 28px;
}

.filterIcon {
  margin-right: 16px;
}

input[type="text"]:focus {
  background-color: lightblue;
}

input[type="date"]:focus {
  outline: none;
  border: 0;
  appearance: none;
  border-width: 0px;
  border: none;
}
</style>